/**
 * Cheie site reCAPTCHA v3 (publică, poate fi în bundle).
 * Folosită pe domeniile Selena când lipsește REACT_APP_RECAPTCHA_SITE_KEY la build
 * (ex. build generic fără .env.production).
 *
 * În Google Admin trebuie înregistrate: selenaservice.ro, www, staging etc.
 */
export const RECAPTCHA_SITE_KEY_FALLBACK = "6Le1ltIsAAAAAOUYxhbpdJ1Pd6r0VXfe4B7s7fee";

/** Hostname curent e producție/staging Selena (subdomenii incluse). */
export function isRecaptchaFallbackHost(hostname) {
  const h = String(hostname || "").toLowerCase();
  if (!h) {
    return false;
  }
  return h === "selenaservice.ro" || h.endsWith(".selenaservice.ro");
}
